import { render } from "./Size.vue?vue&type=template&id=0fe97462&scoped=true&ts=true"
import script from "./Size.vue?vue&type=script&lang=ts"
export * from "./Size.vue?vue&type=script&lang=ts"

import "./Size.vue?vue&type=style&index=0&id=0fe97462&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe97462"]])

export default __exports__